// extracted by mini-css-extract-plugin
module.exports = {"area-form":"AreaForm_area-form__149D1","area-row":"AreaForm_area-row__deY1_","form-group":"AreaForm_form-group__26pVF","icon":"AreaForm_icon__1ESB8"};